import Vue from 'vue';

function createStage( data ){
	return new Vue({
		data(){
			return data
		},

		computed:{
			backgroundColor(){
				return this.color || '#0082AD'
			},
			topLevelVerticals(){
				return this.verticals.filter(v => !v.parent);
			}
		}

	})
}

function createCompany( slug, data ){
	return new Vue({
		data(){
			return {
				data: data || {},
				loading: false
			}
		},

		created(){
			if( !this.data.id ){
				// we need to load this
				this.loading = true;
				fetch('/wp-json/wp/v2/tech-company?slug='+slug+'&_embed')
					.then( response => response.json() )
					.then( results => {
						this.loading = false;
						this.data = results[0]
					});
			}
		}
	})
}

const store = new Vue({
	data(){
		return {
			techStack: [],
			extraPanel: null,
			companies: new Map(),
			introduction: ''
		}
	},

	computed: {
		stages(){
			return this.techStack.map( createStage );
		},
		verticals(){
			const verticals = [];
			this.stages.forEach( stage => {
				const mapped = stage.verticals.map( vertical => {
					// vertical 
					return Object.assign({
						stage
					}, vertical);
				});
				stage.verticals = mapped;
				verticals.push(...mapped);
			});
			return verticals;
		}
	},

	methods: {
		setTechStack( stack ){
			this.techStack = stack;
		},
		setExtraPanel( extraPanel ){
			this.extraPanel = extraPanel;
		},
		stage( slug ){
			return this.stages.find( s => s.slug == slug );
		},
		stageById( id ){
			return this.stages.find( s => s.id == id );
		},
		vertical( slug ){
			const parts = slug.replace(/(^\/|\/$)/g, '').split('/');
			const part = parts.pop();
			return this.verticals.find( v => {
				return v.slug == part 
			});
		},
		verticalById( id ){
			return this.verticals.find( v => v.id == id );
		},

		getCompany( slug ){
			if( !this.companies.get(slug) ){
				this.companies.set(slug, createCompany(slug))
			}
			return this.companies.get(slug);
		},

		setCompany( data ){
			this.companies.set(data.slug, createCompany(data.slug, data))
		},

		setIntroduction( data ) {
			this.introduction = data;
		}
	}
});

export {store};
export default store;

const replaceVerticalText = ( source, verticals ) => {
	if( !source ){
		return '';
	}

	const origLinks = [];
	source = source.replace(
		/<a\s.+?>(.+?)<\/a>/gi, match => {
			origLinks.push(match);
			return '__link_'+(origLinks.length-1)+'__';
		}
	);

	verticals.forEach( v => {
		const name = v.name +'s?';
		const replacements = [name];
		
		if( name.match(' and ') ) replacements.push(
			name.replace(' and ', ' & ')
		);

		const regex = new RegExp( '('+replacements.join('|')+')', 'gi' );
		
		source = source.replace(
			regex,
			'<a href="'+v.link+'">$1</a>'
		);
	});

	source = source.replace(
		/__link_(\d+)__/gi, (matches, idx) => {
			return origLinks[idx];
		}
	);

	return source;
}

export {replaceVerticalText};